import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from './pages/HomePage';
import CookieConsent from './components/CookieConsent';

function App() {
  const [cookieConsent, setCookieConsent] = useState(
    () => localStorage.getItem('cookie_consent')
  );

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setCookieConsent('accepted');
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setCookieConsent('declined');
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage cookieConsent={cookieConsent} />} />
      </Routes>
      {cookieConsent === null && (
        <CookieConsent onAccept={handleAccept} onDecline={handleDecline} />
      )}
    </BrowserRouter>
  );
}

export default App;
